import PropTypes from 'prop-types';

export const playerCardShape = PropTypes.shape({
  plsPlayerId: PropTypes.string.isRequired,
  plsAccountNumber: PropTypes.string.isRequired,
  cardNumber: PropTypes.string.isRequired,
  cardType: PropTypes.string.isRequired
});

export const plsPlayerAccountShape = PropTypes.shape({
  created: PropTypes.string.isRequired, // ISO date string
  plsPlayerId: PropTypes.string.isRequired,
  plsAccountNumber: PropTypes.string.isRequired,
  playerCards: PropTypes.arrayOf(playerCardShape).isRequired
});

export const plsPlayerAccountsShape = PropTypes.arrayOf(plsPlayerAccountShape);
